import { render, staticRenderFns } from "./AilmentEdit.vue?vue&type=template&id=d4122a96"
import script from "./AilmentEdit.vue?vue&type=script&lang=js"
export * from "./AilmentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports